import $ from '../$';
import './on';

$.fn.one = function (types, selector, data, callback) {
  // @ts-ignore
  return this.on(types, selector, data, callback, true);
};